import styles from './SuccessState.module.css';

interface SuccessStateProps {
  title?: string;
  accent?: string;
  message?: string;
}

export function SuccessState({
  title = "Your take",
  accent = 'is in.',
  message = "Your circle drifts into the chorus.",
}: SuccessStateProps) {
  return (
    <div class={styles.container}>
      <div class={styles.viz}>
        <svg width="120" height="120" viewBox="0 0 120 120" aria-hidden="true">
          {/* Pulse rings */}
          <circle cx="60" cy="60" r="54" fill="none" stroke="var(--st-accent-warm)" stroke-width="1" opacity="0.15" />
          <circle cx="60" cy="60" r="42" fill="none" stroke="var(--st-accent-warm)" stroke-width="1" opacity="0.25" />
          {/* Author circles drifting into alignment */}
          <circle cx="40" cy="48" r="22" fill="var(--st-author-1)" opacity="0.6" style={{ mixBlendMode: 'multiply' }} />
          <circle cx="72" cy="42" r="18" fill="var(--st-author-2)" opacity="0.6" style={{ mixBlendMode: 'multiply' }} />
          <circle cx="80" cy="72" r="20" fill="var(--st-author-4)" opacity="0.6" style={{ mixBlendMode: 'multiply' }} />
          <circle cx="48" cy="78" r="19" fill="var(--st-author-5)" opacity="0.6" style={{ mixBlendMode: 'multiply' }} />
        </svg>
      </div>
      <h2 class={styles.title}>
        {title} <span class={styles.titleAccent}>{accent}</span>
      </h2>
      <p class={styles.message}>{message}</p>
    </div>
  );
}
